import { type FC, useMemo } from 'react';
import styles from './SamplePlanTable.module.scss';
import {
  optionSet,
  TableOptions,
  useSamplePlanTableContext,
} from '@/components/Samples/SamplePlanTable/SamplePlanTableProvider';
import { isSubsetOfSets } from '@/utils/browser.utils';
import { IndeterminateCheckbox } from '@/components/UI/Table/Columns/Selector';
import { _notNil } from '@/littledash';

export const Header: FC = () => {
  const {
    active_details,
    active_metadata,
    metadata_glossary,
    table_options,
    sample_definition_rows,
    selection,
    updateRowSelection,
  } = useSamplePlanTableContext();
  const selectionState = useMemo(() => {
    if (selection.size === 0) {
      return false;
    }
    if (isSubsetOfSets(new Set(sample_definition_rows.keys()), selection)) {
      return true;
    }
    return 'indeterminate';
  }, [selection, sample_definition_rows]);

  return (
    <div className={styles.Header} data-test-component="Header" data-test-element="container">
      {optionSet(TableOptions.display_selection_column, table_options) ? (
        <div>
          <IndeterminateCheckbox
            checked={selectionState === true}
            indeterminate={selectionState === 'indeterminate'}
            onChange={() => updateRowSelection({ type: selectionState === true ? 'clear-all' : 'select-all' })}
            className="ui-table-selector"
            data-test-component="IndeterminateCheckbox"
            data-test-element="checkbox-input"
          />
        </div>
      ) : null}
      <div></div>
      <div>Name</div>
      <div>Group</div>
      {optionSet(TableOptions.display_planned_animal_column, table_options) ? <div>Planned animals</div> : null}
      {optionSet(TableOptions.display_registered_animal_column, table_options) ? <div>Animals</div> : null}
      {optionSet(TableOptions.collected_samples_count, table_options) ? (
        <>
          <div>Planned samples</div>
          <div>Samples</div>
        </>
      ) : null}
      <div>Sample type</div>
      <div>Timepoints</div>
      {optionSet(TableOptions.hide_calculate_collection_time_column, table_options) ? null : (
        <div>Calculate collection time</div>
      )}
      {Array.from(active_details).map((detail) => (
        <div key={detail}>{`${detail.charAt(0).toUpperCase()}${detail.slice(1)}`}</div>
      ))}
      {Array.from(active_metadata).map((api_id) => {
        const glossary = metadata_glossary.get(api_id);
        return _notNil(glossary) ? <div key={api_id}>{glossary.title}</div> : null;
      })}
    </div>
  );
};
